var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.199,
    height: 36,
    viewBox: "0 0 25.199 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.216,
    y1: 0.089,
    x2: 0.812,
    y2: 0.844,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#ffc472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.211,
    y1: 0.137,
    x2: 0.814,
    y2: 0.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ffc371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12257",
    "data-name": "Group 12257",
    transform: "translate(-192.131 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M10,24.193a3.679,3.679,0,0,1-2.782-.175,3.624,3.624,0,0,1-1.924-2A3.657,3.657,0,0,1,2.847,20.7a3.592,3.592,0,0,1-.89-2.616A3.616,3.616,0,0,1,.3,15.861a3.578,3.578,0,0,1,.311-2.742,3.58,3.58,0,0,1-.55-2.706A3.6,3.6,0,0,1,1.514,8.055a3.579,3.579,0,0,1,.656-2.683A3.654,3.654,0,0,1,4.493,3.844a3.615,3.615,0,0,1,1.74-2.156,3.493,3.493,0,0,1,3.358-.173l.012,0A3.473,3.473,0,0,1,12.6,0a3.67,3.67,0,0,1,2.6,1.006,3.681,3.681,0,0,1,2.782.173,3.624,3.624,0,0,1,1.925,2A3.658,3.658,0,0,1,22.351,4.5a3.592,3.592,0,0,1,.891,2.616A3.618,3.618,0,0,1,24.9,9.339a3.576,3.576,0,0,1-.311,2.743,3.762,3.762,0,0,1-.9,5.063,3.577,3.577,0,0,1-.656,2.682,3.651,3.651,0,0,1-2.323,1.528,3.617,3.617,0,0,1-1.74,2.157,3.5,3.5,0,0,1-3.366.169,3.471,3.471,0,0,1-3,1.52A3.669,3.669,0,0,1,10,24.193Z",
    transform: "translate(192.131 8)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(195.731 11.6)",
    fill: "#f5f5f8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(198.131 14)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M16.8,12h-.172L12.6,10.22V2.387c.324-.086.643-.185.95-.292A6.943,6.943,0,0,0,16.8,0V12ZM.175,12H0V0A6.955,6.955,0,0,0,3.252,2.095c.3.106.621.2.948.292v7.835L.175,12ZM10.2,9.16h0l-1.8-.8-1.8.8V2.82a17.809,17.809,0,0,0,1.8.091,17.668,17.668,0,0,0,1.8-.091v6.34Z",
    transform: "translate(196.331 31.999)",
    fill: "#f89c1d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(201.128 24.8)",
    fill: "#f5f5f8",
    fontSize: 11,
    fontFamily: "GothamHTF-Bold, Gotham HTF",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadge);
export default __webpack_public_path__ + "static/media/gold-badge.3972bdd25c2e3ac932250b5b7914b338.svg";
export { ForwardRef as ReactComponent };